<mat-toolbar>
  <span><a routerLink="/">BIDAPass</a></span>
  <span class="bda-toolbar-spacer"></span>
  <!-- <button mat-icon-button><mat-icon>notifications</mat-icon></button> -->
  <ng-container *ngIf="!(selectIsLoggedIn$ | async); else loggedIn">
    <a mat-button class="bda-toolbar-link" routerLink="/login">Login</a>
    <!-- <a mat-button class="bda-toolbar-link" routerLink="/login">Sign Up</a> -->
  </ng-container>
  <ng-template #loggedIn>
    <button mat-button (click)="logout()">Logout</button>
  </ng-template>
  <ng-container *ngIf="currentUser$ | async as currentUser">
    <span>{{ currentUser.firstName }}</span>
  </ng-container>
</mat-toolbar>
<mat-divider></mat-divider>
